import React from 'react'
import { connect } from 'dva'
import { modelUtils } from '../../../../utils'
import { framework_tool, component_tool } from '../../../../tool'
import { Checkbox, Col, Row } from 'antd';
let { WizContainer } = framework_tool
let { WizSpin, WizRow, WizCol, WizButton } = component_tool
import { LabelPreconditions } from "@/containers/common";
import './index.less'

class LabelRule extends WizContainer {

  componentName = 'LabelRule'

  constructor(props) {
    super(props)
    this.state = {
      labelId: props.labelId,
      type: 58, //标签类型
      status: 0,
      resetTime: new Date().getTime(),
      checkArr: [],
      saveToNext:0,
      nextOrBack:false,
    }
  }

  _componentDidMount() {
    let { type, labelId } = this.state
    this.doActions([
      {
        path: 'beforeCondition/list',
        payload: {
          key: 'getLabelRule',
          apiParams: { bizType: type, bizId: labelId }
        }
      }
    ])
  }

  _createRule(values) {
    this.doAction({
      path: 'beforeCondition/save',
      payload: {
        key: 'createRule_' + this.state.labelId,
        apiParams: { bizType: 58, bizId: this.state.labelId, ...values }
      }
    })
  }

  _updateRule(values) {
    this.doAction({
      path: 'beforeCondition/save',
      payload: {
        key: 'updateRule_' + this.state.labelId,
        apiParams: { bizType: 58, bizId: this.state.labelId, ...values }
      }
    })
  }

  _saveAndNext = () => {
    let {saveToNext}=this.state
    saveToNext=saveToNext+1
    this.setState({ nextOrBack:true}, () => {
      this.setState({ status: 1,saveToNext:saveToNext}, () => {
        // let values = this._fitterValues()
        // if (this.state.type === 'update') {
        //   this._updateRule(values)
        // } else {
        //   this._createRule(values)
        // }
      })
    })
  }

  _saveAndBack = () => {
    let {saveToNext}=this.state
    saveToNext=saveToNext+1
    this.setState({ nextOrBack:false}, () => {
      this.setState({ status: 1,saveToNext:saveToNext}, () => {
        // let values = this._fitterValues()
        // if (this.state.type === 'update') {
        //   this._updateRule(values)
        // } else {
        //   this._createRule(values)
        // }
      })
    })
    // this.setState({ status: 2 }, () => {
    //   let values = this._fitterValues()
    //   if (this.state.type === 'update') {
    //     this._updateRule(values)
    //   } else {
    //     this._createRule(values)
    //   }
    // })
  }

  _onReset = () => {
    this.setState({ resetTime: new Date().getTime() })
  }

  _fitterValues() {
    return this._label && this._label._fitterValues()
  }

  propsAndStateOnChange = {
    createRule: this._createRuleOnChange.bind(this),
    updateRule: this._updateRuleOnChange.bind(this),
  }

  _createRuleOnChange(nextProps, nextState) {
    if (nextProps.createRule.code === 1) {
      if (this.state.status === 1) {
        this.props.nextFunc && this.props.nextFunc()
      } else if (this.state.status === 2) {
        this.props.backFunc && this.props.backFunc()
      }
    }
    return true
  }

  _updateRuleOnChange(nextProps, nextState) {
    if (nextProps.updateRule.code === 1) {
      if (this.state.status === 1) {
        this.props.nextFunc && this.props.nextFunc()
      } else if (this.state.status === 2) {
        this.props.backFunc && this.props.backFunc()
      }
    } else {
      wizNotice.error(nextProps.updateRule.msg)
      return false;
    }
    return true
  }

  _prev = () => {
    this.props.prevFunc && this.props.prevFunc()
  }
  onChange = (e) => {
    let checkArr = [...this.state.checkArr]

    console.log('checked = ', e.target.value)
    if (checkArr.findIndex(x => x == e.target.value) == -1) {
      checkArr.push(e.target.value)
    } else {
      checkArr = checkArr.filter(x => x != e.target.value)
    }
    this.setState({ checkArr: checkArr })
  };
  addChecked = (value) => {
    console.log('value = ', value);

    this.setState({ checkArr: value })

  }
  jumpNext=()=>{
    if (this.state.status === 1) {
      this.props.nextFunc && this.props.nextFunc()
    } else if (this.state.status === 2) {
      this.props.backFunc && this.props.backFunc()
    }
  }
  jumpBack=()=>{
    const {backFunc}=this.props
    backFunc();
  }
  renderList = (checkArr) => {
    let { labelId } = this.props
    let {saveToNext,nextOrBack}=this.state
    return (
      <div className='right-inner-box'>
        {/* <div className='title-box'>
          <div>{title}</div>
          <div><CloseOutlined /></div>
        </div>
        <div className='table-box'> */}
        <LabelPreconditions jumpBack={this.jumpBack} jumpNext={this.jumpNext} checkArr={checkArr} bizId={labelId} addChecked={this.addChecked} saveToNext={saveToNext} nextOrBack={nextOrBack}></LabelPreconditions>
        {/* </div> */}
      </div>
    )
  }
  _render() {
    let { checkArr } = this.state
    const checkList = [
      { value: '0', label: '在线课程' },
      { value: '8', label: '培训主题' },
      { value: '1', label: '考试' },
      { value: '30', label: '作业' },
      { value: '12', label: '路径' },
    ]
    return (
      <div className='rule-out-body'>
        <WizSpin tip={'加载中'} spinning={this.props.beforeConditionLoading}>
          <div className='rule-box'>
            {/* <Checkbox.Group style={{ width: '100%' }} onChange={this.onChange} > */}
            <div className='rule-left-box'>
              <div className='left-title'>业务类型</div>
              <div className='left-check'>
                <Row>
                  {checkList.map(item => {
                    return (
                      <Col span={24}>
                        <Checkbox value={item.value} onChange={this.onChange} checked={checkArr.findIndex(x => x == item.value) > -1}>{item.label}</Checkbox>
                      </Col>
                    )
                  })}
                </Row>
              </div>

            </div>
            {/* </Checkbox.Group> */}
            <div className='right-box'>
              {this.renderList(checkArr)

              }
            </div>
          </div>
          <WizRow className='label-button-row-bottom'>
            <WizCol>
              <WizButton title='上一步' onClick={this._prev}>上一步</WizButton>
              <WizButton title='保存并进入下一步' type='primary' onClick={this._saveAndNext}>保存并进入下一步</WizButton>
              <WizButton title='保存并返回' onClick={this._saveAndBack}>保存并返回</WizButton>
              {/* <WizButton title='重置' type='reset' onClick={this._onReset}>重置</WizButton> */}
            </WizCol>
          </WizRow>
        </WizSpin>
      </div>
    )
  }

}

const mapStateToProps = (state, ownProps) => {
  const { beforeCondition } = state
  let { labelId } = ownProps
  const createRule = modelUtils.getModelEntity(beforeCondition, 'createRule_' + labelId)
  const updateRule = modelUtils.getModelEntity(beforeCondition, 'updateRule_' + labelId)
  const labelRule = modelUtils.getModelEntity(beforeCondition, "getLabelRule");
  const load = modelUtils.getLoadingState(state, ['beforeCondition'])
  return {
    createRule,
    updateRule,
    labelRule,
    ...load
  }
}

export default connect(mapStateToProps)(LabelRule)
